import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import { Component } from 'react';
import where from 'transmute/where';
import getIn from 'transmute/getIn';
import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { SuccessIcon } from 'foundations-assets';
import { getInboxesCount } from 'conversations-internal-schema/inbox/operators/getInboxesCount';
import { getName, getId } from 'conversations-internal-schema/inbox/operators/inboxGetters';
import { trackEvent, trackEventBeforeUnload } from '../../usage-tracking/clients/usageTracker';
import { clickToChangeInbox, clickedInboxSettings } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { Select } from 'foundations-components/transitional/components/Select';
import { Flex } from 'foundations-components/components/Flex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CustomItemComponent = _ref => {
  let {
      children,
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const finalChildren = /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexWrap: "nowrap",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "span",
      truncate: true,
      children: children
    }), /*#__PURE__*/_jsx("span", {
      children: option.isSelected && /*#__PURE__*/_jsx(IconHolder, {
        icon: SuccessIcon,
        color: "icon-core-subtle",
        marginInlineEnd: "200",
        size: "300"
      })
    })]
  });
  const finalProps = Object.assign({}, rest, {
    children: finalChildren
  });
  return /*#__PURE__*/_jsx("li", Object.assign({}, finalProps));
};
CustomItemComponent.displayName = 'CustomItemComponent';
class InboxSelect extends Component {
  constructor(...args) {
    super(...args);
    this.handleClickInboxSettings = () => {
      trackEventBeforeUnload(clickedInboxSettings);
    };
    this.renderSelectValue = () => {
      const {
        currentInbox
      } = this.props;
      return /*#__PURE__*/_jsx(Text, {
        as: "h5",
        color: "text-core-default",
        margin: "0",
        truncate: true,
        children: getName(currentInbox)
      });
    };
    this.renderSingleHeader = () => {
      const {
        inboxes,
        currentInbox
      } = this.props;
      const inboxName = getInboxesCount(inboxes) === 1 ? getName(currentInbox) : I18n.text('conversations-inbox-ui.unified-inbox.header');
      return /*#__PURE__*/_jsx("div", {
        style: {
          width: '100%',
          height: '100%',
          alignItems: 'flex-end'
        },
        children: /*#__PURE__*/_jsx(Text, {
          as: "h5",
          color: "text-core-default",
          margin: "0",
          padding: "200",
          truncate: true,
          children: /*#__PURE__*/_jsx(TruncateString, {
            children: inboxName
          })
        })
      });
    };
  }
  render() {
    const {
      inboxes,
      currentInbox,
      onInboxSelect
    } = this.props;
    if (!currentInbox || getInboxesCount(inboxes) === 0 || getInboxesCount(inboxes) === 1) {
      return this.renderSingleHeader();
    }
    return /*#__PURE__*/_jsx(Select, {
      "data-test-id": "inbox-select-dropdown",
      searchable: false,
      buttonUse: "transparent",
      placement: "bottom right",
      onOpenChange: evt => {
        const isOpen = getIn(['currentTarget', 'value'], evt);
        if (isOpen) {
          trackEvent(clickToChangeInbox);
        }
      },
      menuWidth: 250,
      onChange: ({
        target: {
          value
        }
      }) => {
        const inbox = where({
          id: value
        }, inboxes).get(0);
        onInboxSelect(inbox);
      },
      valueComponent: this.renderSelectValue,
      itemComponent: CustomItemComponent,
      options: inboxes.map(inbox => ({
        text: getName(inbox),
        value: getId(inbox),
        isSelected: getId(inbox) === getId(currentInbox)
      })).toJS()
    });
  }
}
InboxSelect.displayName = 'InboxSelect';
export default InboxSelect;